import { createReducer } from 'deox';
import { OptionFilter, Categories, Category } from '@/types';
import { fetchCategoriesActions, fetchCategoryByIdActions } from '@/redux/actions/service-directory/category';

export interface CategoryState {
  api?: { [checkbox: string]: OptionFilter };
  app?: { [checkbox: string]: OptionFilter };
  categories?: Categories;
  category?: Category;
}

const initialState: CategoryState = {
  api: undefined,
  app: undefined,
  categories: undefined,
  category: undefined,
};

const serviceDirectoryEntityReducer = createReducer(initialState, (handleAction) => [
  handleAction(fetchCategoriesActions.success, (state, { payload }) => {
    const { entryType, filterOptions, categories } = payload;
    return {
      ...state,
      [entryType.toLowerCase()]: filterOptions,
      categories,
    };
  }),
  handleAction(fetchCategoryByIdActions.success, (state, { payload }) => ({
    ...state,
    category: payload,
  })),
]);

export default serviceDirectoryEntityReducer;
